export const allNamespacesSelector = (state: any) => state.featureGeneration.namespaces.namespaceList;